import { OkdocLandingsPageContent } from '@/features/okdoc/admin/OkdocLandingsPageContent';

export function OkdocLandingsPage() {
  return <OkdocLandingsPageContent />;
}
